module.exports = __webpack_public_path__ + "images/rate.bbfcdf1.svg";